import React, { useState, useRef, useEffect } from "react";
import { Container, Row, Col, Form, Button, Table, Modal, Spinner, Alert } from "react-bootstrap";
import { FaTrash, FaPlus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import api from "../services/api";
import "./AddPurchase.css";

const AddInvoice = () => {
  const [formData, setFormData] = useState({
    customer_id: "",
    date: new Date().toISOString().split('T')[0],
    gst_percentage: 18,
    packageCharges: 0,
    notes: "",
    delivery_note_id: "",
    productSearch: "",
    sellingRate: "",
    qty: "",
    selectedProduct: null
  });

  const [invoiceItems, setInvoiceItems] = useState([]);
  const [errors, setErrors] = useState({});
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [showProductDropdown, setShowProductDropdown] = useState(false);
  const [showDeliveryNoteDropdown, setShowDeliveryNoteDropdown] = useState(false);
  const [loading, setLoading] = useState(false);
  const [submitError, setSubmitError] = useState("");
  const [packing_percentage, setPackingPercentage] = useState("");
  const [customers, setCustomers] = useState([]);
  const [products, setProducts] = useState([]);
  const [deliveryNotes, setDeliveryNotes] = useState([]);
  const [selectedCustomerAddress, setSelectedCustomerAddress] = useState("");
  const [fetchingDeliveryNote, setFetchingDeliveryNote] = useState(false);

  // Customer modal states
  const [newCustomer, setNewCustomer] = useState({
    name: "",
    mobile: "",
    address: "",
    gst_no: "",
    state: "",
    city: "",
    pin_code: ""
  });
  const [customerErrors, setCustomerErrors] = useState({});
  const [isAddingCustomer, setIsAddingCustomer] = useState(false);
  const [customerSuccess, setCustomerSuccess] = useState("");

  // Refs for input fields
  const customerRef = useRef(null);
  const dateRef = useRef(null);
  const deliveryNoteRef = useRef(null);
  const productSearchRef = useRef(null);
  const sellingRateRef = useRef(null);
  const qtyRef = useRef(null);
  const notesRef = useRef(null);

  const navigate = useNavigate();

  // Fetch customers, products, and UNINVOICED delivery notes from API
  useEffect(() => {
    fetchDropdownData();
  }, []);

  const fetchDropdownData = async () => {
    try {
      // Fetch customers
      const customersResponse = await api.post("/customer_list.php", {});
      if (customersResponse.data.head.code === 200) {
        setCustomers(customersResponse.data.body);
      }

      // Fetch products
      const productsResponse = await api.post("/product_list.php", {});
      if (productsResponse.data.head.code === 200) {
        setProducts(productsResponse.data.body);
        setPackingPercentage(productsResponse.data.body[0]['packing_percentage']);
      }

      // Fetch ONLY UNINVOICED delivery notes for dropdown
      const deliveryNotesResponse = await api.post("/delivery_note_uninvoiced_list.php", {});
      if (deliveryNotesResponse.data.head.code === 200) {
        setDeliveryNotes(deliveryNotesResponse.data.body);
      }
    } catch (err) {
      console.error("Error fetching dropdown data:", err);
    }
  };
  /*
    // Function to fetch delivery note details (only customer info, not items)
    const fetchDeliveryNoteDetails = async (deliveryNoteId) => {
      try {
        setFetchingDeliveryNote(true);
        const response = await api.post("/delivery_note_detail.php", { id: deliveryNoteId });
        
        if (response.data.head.code === 200) {
          const data = response.data.body;
          
          // Set customer from delivery note
          setFormData(prev => ({ 
            ...prev, 
            customer_id: data.customer_id,
            delivery_note_id: deliveryNoteId
          }));
          
          // Set customer address
          if (data.customer_name || data.customer_address) {
            const addressParts = [];
            if (data.customer_address) addressParts.push(data.customer_address);
            if (data.customer_city) addressParts.push(data.customer_city);
            if (data.customer_state) addressParts.push(data.customer_state);
            if (data.customer_pin_code) addressParts.push(data.customer_pin_code);
            setSelectedCustomerAddress(addressParts.join(", "));
          }
          
          // Show success message
          alert(`Delivery Note #${deliveryNoteId} loaded. Customer set to ${data.customer_name || data.customer_id}.`);
        } else {
          alert("Failed to fetch delivery note details.");
        }
      } catch (err) {
        console.error("Error fetching delivery note:", err);
        alert("Failed to fetch delivery note details.");
      } finally {
        setFetchingDeliveryNote(false);
      }
    };
    */
  const fetchDeliveryNoteDetails = async (deliveryNoteId) => {
    try {
      setFetchingDeliveryNote(true);

      const response = await api.post("/delivery_note_detail.php", {
        id: deliveryNoteId
      });

      if (response.data.head.code === 200) {
        const data = response.data.body;

        /* 1️⃣ Set customer */
        setFormData(prev => ({
          ...prev,
          customer_id: data.customer_id,
          delivery_note_id: deliveryNoteId
        }));

        /* 2️⃣ Set customer address */
        const addressParts = [];
        if (data.customer_address) addressParts.push(data.customer_address);
        if (data.customer_city) addressParts.push(data.customer_city);
        if (data.customer_state) addressParts.push(data.customer_state);
        if (data.customer_pin_code) addressParts.push(data.customer_pin_code);
        setSelectedCustomerAddress(addressParts.join(", "));

        /* 3️⃣ SET PRODUCTS FROM DELIVERY NOTE ✅ */
        if (Array.isArray(data.items)) {
          // console.log("full data is",data.items);
          /*
          const mappedItems = data.items.map(item => ({
            product_code: item.product_code,
            product_name: item.item_name,
            selling_rate: parseFloat(item.selling_rate),
            quantity: parseInt(item.quantity),
            total:
              parseFloat(item.selling_rate) * parseInt(item.quantity)
          }));
          */
          const mappedItems = data.items.map(item => {
            const sellingRate = Number(item.selling_rate) || 0;
            const quantity = Number(item.quantity) || 0;
            console.log("data is ", item.id);
            return {
              product_id: item.product_id,
              product_name: item.item_name,
              delivery_note_item_id: item.id,
              selling_rate: sellingRate,
              quantity: quantity,
              total: sellingRate * quantity
            };
          });

console.log("mapped items ",mappedItems);
          setInvoiceItems(mappedItems);
        } else {
          setInvoiceItems([]);
        }

        alert(`Delivery Note #${deliveryNoteId} loaded successfully`);
      } else {
        alert("Failed to fetch delivery note details");
      }
    } catch (err) {
      console.error("Error fetching delivery note:", err);
      alert("Failed to fetch delivery note details");
    } finally {
      setFetchingDeliveryNote(false);
    }
  };

  // Filter UNINVOICED delivery notes based on search input
  const getFilteredDeliveryNotes = () => {
    if (!formData.delivery_note_id) {
      return deliveryNotes.slice(0, 10);
    }

    const searchTerm = formData.delivery_note_id.toLowerCase();
    const filtered = deliveryNotes.filter(deliveryNote => {
      const deliveryNoteNo = deliveryNote.id || "";
      const customerName = deliveryNote.customer_name || "";
      const invoiceNo = deliveryNote.invoice_no || "";

      return (
        deliveryNoteNo.toString().toLowerCase().includes(searchTerm) ||
        customerName.toLowerCase().includes(searchTerm) ||
        invoiceNo.toLowerCase().includes(searchTerm)
      );
    });
    return filtered.slice(0, 10);
  };

  // Filter products based on search input
  const getFilteredProducts = () => {
    if (!formData.productSearch) {
      return products.slice(0, 10);
    }

    const searchTerm = formData.productSearch.toLowerCase();
    const filtered = products.filter(product => {
      const hsnCode = product.hsn_code || product.code || "";
      const productName = product.name || product.product_name || "";
      return (
        hsnCode.toLowerCase().includes(searchTerm) ||
        productName.toLowerCase().includes(searchTerm)
      );
    });
    return filtered.slice(0, 10);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'customer_id') {
      // Find selected customer to get their address
      const selectedCustomer = customers.find(c => c.id == value);
      if (selectedCustomer) {
        // Build the address string
        const addressParts = [];
        if (selectedCustomer.address) addressParts.push(selectedCustomer.address);
        if (selectedCustomer.city) addressParts.push(selectedCustomer.city);
        if (selectedCustomer.state) addressParts.push(selectedCustomer.state);
        if (selectedCustomer.pin_code) addressParts.push(selectedCustomer.pin_code);

        setSelectedCustomerAddress(addressParts.join(", "));
      } else {
        setSelectedCustomerAddress("");
      }
    }

    setFormData(prev => ({ ...prev, [name]: value }));

    if (name === 'productSearch') {
      setShowProductDropdown(true);
    } else if (name === 'delivery_note_id') {
      setShowDeliveryNoteDropdown(true);
    }
  };

  // Handle delivery note selection from dropdown or Enter key
  const handleDeliveryNoteSelect = (deliveryNote) => {
    const deliveryNoteId = deliveryNote.id || "";
    setFormData(prev => ({
      ...prev,
      delivery_note_id: deliveryNoteId.toString(),
    }));
    setShowDeliveryNoteDropdown(false);

    // Fetch the selected delivery note details (only for customer info)
    fetchDeliveryNoteDetails(deliveryNoteId);

    // Focus on product search after loading
    // setTimeout(() => {
    //   productSearchRef.current.focus();
    // }, 500);
  };

  // Handle product selection from dropdown
  const handleProductSelect = (product) => {
    const productName = product.name || product.product_name || "";
    const hsnCode = product.hsn_code || product.code || "";

    setFormData(prev => ({
      ...prev,
      productSearch: `${hsnCode} - ${productName}`,
      selectedProduct: {
        hsn_code: hsnCode,
        name: productName,
        id: product.id
      }
    }));
    setShowProductDropdown(false);
    sellingRateRef.current.focus();
  };

  const handleAddItem = () => {
    if (!formData.selectedProduct || !formData.sellingRate || !formData.qty) {
      alert("Please fill all product fields");
      return;
    }

    const newItem = {
      product_code: formData.selectedProduct.hsn_code || '',
      product_name: formData.selectedProduct.name,
      selling_rate: parseFloat(formData.sellingRate) || 0,
      quantity: parseInt(formData.qty) || 1,
      total: (parseFloat(formData.sellingRate) || 0) * (parseInt(formData.qty) || 1)
    };

    setInvoiceItems([...invoiceItems, newItem]);

    // Reset product fields only
    setFormData(prev => ({
      ...prev,
      productSearch: "",
      selectedProduct: null,
      sellingRate: "",
      qty: ""
    }));

    // Focus back on product search for next entry
    productSearchRef.current.focus();
    setShowProductDropdown(false);
  };

  // Enter key navigation handler
  const handleKeyPress = (e, nextFieldRef, action = null) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (action) {
        action();
      } else if (nextFieldRef && nextFieldRef.current) {
        nextFieldRef.current.focus();
      }
    }
  };

  // Special handler for delivery note field
  const handleDeliveryNoteKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const value = formData.delivery_note_id;
      if (value && value.trim() !== "") {
        // Try to find the delivery note in the list
        const deliveryNote = deliveryNotes.find(dn => dn.id == value);
        if (deliveryNote) {
          handleDeliveryNoteSelect(deliveryNote);
        } else {
          // If not found in list, still try to fetch details
          fetchDeliveryNoteDetails(value);
        }
      }
      // productSearchRef.current.focus();
    }
  };

  // Special handler for product search
  const handleProductSearchKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const filtered = getFilteredProducts();
      if (filtered.length === 1) {
        handleProductSelect(filtered[0]);
      } else if (filtered.length > 0 && formData.productSearch) {
        sellingRateRef.current.focus();
      }
    }
  };

  // Special handler for selling rate field
  const handleSellingRateKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (formData.selectedProduct && formData.sellingRate) {
        qtyRef.current.focus();
      }
    }
  };

  // Special handler for quantity field to add item
  const handleQtyKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddItem();
    }
  };

  const handleGstChange = (e) => {
    const value = e.target.value;
    setFormData(prev => ({ ...prev, gst_percentage: value }));
  };

  const handlePackageChargesChange = (e) => {
    const value = e.target.value;
    setFormData(prev => ({ ...prev, packageCharges: parseFloat(value) || 0 }));
  };

  const handleItemChange = (index, field, value) => {
    const updatedItems = [...invoiceItems];

    if (field === 'selling_rate') {
      updatedItems[index].selling_rate = parseFloat(value) || 0;
    } else if (field === 'quantity') {
      updatedItems[index].quantity = parseInt(value) || 0;
    }

    // Calculate total if selling rate or quantity changes
    if (field === 'selling_rate' || field === 'quantity') {
      updatedItems[index].total = updatedItems[index].selling_rate * updatedItems[index].quantity;
    }

    setInvoiceItems(updatedItems);
  };

  const handleDeleteItem = (index) => {
    const updatedItems = invoiceItems.filter((_, i) => i !== index);
    setInvoiceItems(updatedItems);
  };

  // Customer Modal Functions
  const handleShowCustomerModal = () => {
    setShowCustomerModal(true);
    setCustomerErrors({});
    setCustomerSuccess("");
  };

  const handleCloseCustomerModal = () => {
    setShowCustomerModal(false);
    // Reset form
    setNewCustomer({
      name: "",
      mobile: "",
      address: "",
      gst_no: "",
      state: "",
      city: "",
      pin_code: ""
    });
    setCustomerErrors({});
    setCustomerSuccess("");
    setIsAddingCustomer(false);
  };

  // Handle new customer form change
  const handleNewCustomerChange = (e) => {
    const { name, value } = e.target;
    setNewCustomer(prev => ({ ...prev, [name]: value }));
    // Clear error for this field when user starts typing
    if (customerErrors[name]) {
      setCustomerErrors(prev => ({ ...prev, [name]: "" }));
    }
  };

  // Validate customer form
  const validateCustomer = () => {
    const errors = {};

    if (!newCustomer.name.trim()) {
      errors.name = "Customer name is required";
    }

    if (!newCustomer.mobile.trim()) {
      errors.mobile = "Mobile number is required";
    } else if (!/^\d{10}$/.test(newCustomer.mobile)) {
      errors.mobile = "Enter a valid 10-digit mobile number";
    }

    return errors;
  };

  // Handle adding customer via API
  const handleAddCustomer = async () => {
    const validationErrors = validateCustomer();

    if (Object.keys(validationErrors).length > 0) {
      setCustomerErrors(validationErrors);
      return;
    }

    try {
      setIsAddingCustomer(true);
      setCustomerSuccess("");
      setCustomerErrors({});

      // Prepare payload matching customer_add.php API
      const payload = {
        name: newCustomer.name,
        mobile: newCustomer.mobile,
        gst_no: newCustomer.gst_no || "",
        state: newCustomer.state || "",
        city: newCustomer.city || "",
        address: newCustomer.address || "",
        pin_code: newCustomer.pin_code || ""
      };

      // Call the customer_add.php API
      const response = await api.post("/customer_add.php", payload);

      if (response.data.head.code === 200) {
        // Success - add new customer to local state
        const newCustomerObj = {
          id: response.data.body.customer_id,
          name: newCustomer.name,
          mobile: newCustomer.mobile,
          gst_no: newCustomer.gst_no,
          state: newCustomer.state,
          city: newCustomer.city,
          address: newCustomer.address,
          pin_code: newCustomer.pin_code
        };

        // Add to customers list
        setCustomers(prev => [...prev, newCustomerObj]);

        // Auto-select the new customer
        setFormData(prev => ({
          ...prev,
          customer_id: response.data.body.customer_id
        }));

        // Set the address for the new customer
        const addressParts = [];
        if (newCustomer.address) addressParts.push(newCustomer.address);
        if (newCustomer.city) addressParts.push(newCustomer.city);
        if (newCustomer.state) addressParts.push(newCustomer.state);
        if (newCustomer.pin_code) addressParts.push(newCustomer.pin_code);
        setSelectedCustomerAddress(addressParts.join(", "));

        // Show success message
        setCustomerSuccess(`Customer "${newCustomer.name}" added successfully!`);

        // Reset form and close modal after 2 seconds
        setTimeout(() => {
          handleCloseCustomerModal();
          // Focus back on customer dropdown
          if (customerRef.current) {
            customerRef.current.focus();
          }
        }, 2000);

      } else {
        // Handle API error
        const errorMsg = response.data.head.msg || "Failed to add customer";
        setCustomerErrors({ api: errorMsg });
      }
    } catch (err) {
      console.error("Error adding customer:", err);

      let errorMessage = "Failed to add customer. Please try again.";

      if (err.response) {
        errorMessage = err.response.data?.head?.msg || errorMessage;
      } else if (err.request) {
        errorMessage = "No response from server. Please check your connection.";
      }

      setCustomerErrors({ api: errorMessage });
    } finally {
      setIsAddingCustomer(false);
    }
  };

  // Handle keydown in customer modal
  const handleCustomerKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleAddCustomer();
    }
  };

  const calculateSubTotal = () => {
    return invoiceItems.reduce((total, item) => total + (item.total || 0), 0);
  };

  const calculateGST = () => {
    const subTotal = calculateSubTotal();
    return (subTotal * (parseFloat(formData.gst_percentage) / 100));
  };

  // const calculatePackageCharges = () => {
  //   return parseFloat(formData.packageCharges) || 0;
  // };

  const calculatePackageCharges = () => {
    const subTotal = calculateSubTotal();
    const percentage = packing_percentage; // fixed 5%
    return (subTotal * percentage) / 100;
  };


  const calculateGrandTotal = () => {
    const subTotal = calculateSubTotal();
    const gst = calculateGST();
    const packageCharges = calculatePackageCharges();
    return subTotal + gst + packageCharges;
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.customer_id) newErrors.customer_id = "Customer is required";
    if (!formData.date) newErrors.date = "Date is required";
    if (invoiceItems.length === 0) newErrors.items = "At least one item is required";
    return newErrors;
  };

  const generateInvoicePayload = () => {
    const subTotal = calculateSubTotal();
    const gstAmount = calculateGST();
    const packageCharges = calculatePackageCharges();
    const grandTotal = calculateGrandTotal();

    const formatDateToDMY = (date) => {
  if (!date) return "";
  const [yyyy, mm, dd] = date.split("-");
  return `${dd}-${mm}-${yyyy}`;
};

    // Prepare the payload
    const payload = {
      customer_id: parseInt(formData.customer_id) || 0,
      date: formatDateToDMY(formData.date),
      sub_total: subTotal.toFixed(2),
      gst_percentage: parseFloat(formData.gst_percentage),
      gst_amount: gstAmount.toFixed(2),
      package_charges: packageCharges.toFixed(2),
      grand_total: grandTotal.toFixed(2),
      notes: formData.notes || "",
      items: invoiceItems.map(item => ({
        delivery_note_item_id: item.delivery_note_item_id,
        product_id: item.product_id,
        selling_rate: parseFloat(item.selling_rate),
        quantity: parseInt(item.quantity),
        total: parseFloat(item.total)
      }))
    };

    // Add delivery_note_id if it's not empty
    if (formData.delivery_note_id && formData.delivery_note_id.trim() !== "") {
      payload.delivery_note_id = parseInt(formData.delivery_note_id);
    } else {
      payload.delivery_note_id = 0;
    }

    // Set proforma_id and quotation_id to 0 as per requirement
    // payload.proforma_id = 0;
    // payload.quotation_id = 0;

    return payload;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    try {
      setLoading(true);
      setSubmitError("");

      const payload = generateInvoicePayload();
      console.log("invoice payload ", payload);
      /* */
      const response = await api.post("/invoice_add.php", payload);
      
      if (response.data.head.code === 200) {
        alert(`Invoice #${response.data.body.invoice_id} created successfully!`);
        navigate("/invoice");
      } else {
        const errorMsg = response.data.head.msg || "Failed to create invoice";
        setSubmitError(errorMsg);
      }
      
    } catch (err) {
      console.error("Error creating invoice:", err);
      setSubmitError("Failed to create invoice. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const renderError = (field) =>
    errors[field] ? <div className="text-danger small mt-1">{errors[field]}</div> : null;

  // Render customer field error
  const renderCustomerError = (field) =>
    customerErrors[field] ? (
      <div className="text-danger small mt-1">{customerErrors[field]}</div>
    ) : null;

  return (
    <Container className="mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">Create Invoice</h4>
        <Button className="btn-top" onClick={() => navigate(-1)} disabled={loading}>
          Back
        </Button>
      </div>

      {submitError && (
        <Alert variant="danger" className="mb-3">
          {submitError}
        </Alert>
      )}

      <Form onSubmit={handleSubmit} noValidate>
        <Row className="g-3">
          {/* Customer and Address Row */}
          <Col lg={4} md={4} sm={12}>
            <Form.Group>
              <Form.Label>Select Customer</Form.Label>
              <div className="d-flex gap-2">
                <Form.Select
                  ref={customerRef}
                  name="customer_id"
                  value={formData.customer_id}
                  onChange={handleChange}
                  onKeyPress={(e) => handleKeyPress(e, dateRef)}
                  disabled={loading}
                  isInvalid={!!errors.customer_id}
                >
                  <option value="">Select Customer</option>
                  {customers.map((customer) => (
                    <option key={customer.id} value={customer.id}>
                      {customer.name}
                    </option>
                  ))}
                </Form.Select>
                <Button
                  variant="outline-primary"
                  onClick={handleShowCustomerModal}
                  className="d-flex align-items-center"
                  title="Add New Customer"
                  disabled={loading}
                  type="button"
                >
                  <FaPlus />
                </Button>
              </div>
              {renderError("customer_id")}
            </Form.Group>
          </Col>

          <Col lg={5} md={5} sm={12}>
            <Form.Group>
              <Form.Label>Address</Form.Label>
              <Form.Control
                type="text"
                value={selectedCustomerAddress}
                readOnly
                placeholder="Address will appear after selecting customer or delivery note"
                className="address-field"
              />
            </Form.Group>
          </Col>

          <Col lg={3} md={3} sm={12}>
            <Form.Group>
              <Form.Label>Date</Form.Label>
              <Form.Control
                ref={dateRef}
                name="date"
                type="date"
                value={formData.date}
                onChange={handleChange}
                onKeyPress={(e) => handleKeyPress(e, deliveryNoteRef)}
                disabled={loading}
                isInvalid={!!errors.date}
              />
              {renderError("date")}
            </Form.Group>
          </Col>

          {/* Delivery Note Search Row - SHOWS ONLY UNINVOICED NOTES */}
          <Col lg={12} md={12} sm={12}>
            <Form.Group className="position-relative">
              <Form.Label>Delivery Note Number *</Form.Label>
              <div className="d-flex align-items-center">
                <Form.Control
                  ref={deliveryNoteRef}
                  name="delivery_note_id"
                  type="text"
                  value={formData.delivery_note_id}
                  onChange={handleChange}
                  onFocus={() => setShowDeliveryNoteDropdown(true)}
                  onBlur={() => setTimeout(() => setShowDeliveryNoteDropdown(false), 200)}
                  onKeyPress={handleDeliveryNoteKeyPress}
                  placeholder="Enter delivery note number to set customer..."
                  autoComplete="off"
                  disabled={loading || fetchingDeliveryNote}
                />
                {fetchingDeliveryNote && (
                  <Spinner animation="border" size="sm" className="ms-2" />
                )}
              </div>

              {showDeliveryNoteDropdown && (
                <div className="custom-dropdown">
                  {getFilteredDeliveryNotes().map((deliveryNote, index) => {
                    const deliveryNoteId = deliveryNote.id || "";
                    const customerName = deliveryNote.customer_name || "";
                    const invoiceNo = deliveryNote.invoice_no || "";
                    return (
                      <div
                        key={deliveryNote.id || index}
                        className="dropdown-item"
                        onClick={() => handleDeliveryNoteSelect(deliveryNote)}
                      >
                        <div className="fw-bold">Delivery Note #{deliveryNoteId}</div>
                        {customerName && (
                          <div className="small text-muted">Customer: {customerName}</div>
                        )}
                        {deliveryNote.date && (
                          <div className="small text-muted">Date: {deliveryNote.date}</div>
                        )}
                        {invoiceNo && (
                          <div className="small text-muted">Invoice No: {invoiceNo}</div>
                        )}
                        <div className="small text-success">
                          ✅ Available for invoicing
                        </div>
                      </div>
                    );
                  })}
                  {getFilteredDeliveryNotes().length === 0 && (
                    <div className="dropdown-item text-muted">
                      {formData.delivery_note_id
                        ? "No matching uninvoiced delivery notes found"
                        : "No uninvoiced delivery notes available"}
                    </div>
                  )}
                </div>
              )}
              <div className="form-text">
                Only delivery notes that haven't been invoiced yet will appear here.
                Selecting a delivery note will automatically set customer details.
              </div>
            </Form.Group>
          </Col>

          {/* Product Search Row 
          <Col lg={6} md={6} sm={12}>
            <Form.Group className="position-relative">
              <Form.Label>Search Product *</Form.Label>
              <Form.Control
                ref={productSearchRef}
                name="productSearch"
                type="text"
                value={formData.productSearch}
                onChange={handleChange}
                onFocus={() => setShowProductDropdown(true)}
                onBlur={() => setTimeout(() => setShowProductDropdown(false), 200)}
                onKeyPress={handleProductSearchKeyPress}
                placeholder="Type Product Code or Name"
                autoComplete="off"
                disabled={loading}
              />
              {showProductDropdown && (
                <div className="custom-dropdown">
                  {getFilteredProducts().map((product) => {
                    const productName = product.name || product.product_name || "";
                    const productCode = product.id || "";
                    return (
                      <div
                        key={product.id}
                        className="dropdown-item"
                        onClick={() => handleProductSelect(product)}
                      >
                        <div className="fw-bold">{productCode} - {productName}</div>
                      </div>
                    );
                  })}
                  {getFilteredProducts().length === 0 && (
                    <div className="dropdown-item text-muted">
                      No products found
                    </div>
                  )}
                </div>
              )}
            </Form.Group>
          </Col>

          <Col lg={2} md={2} sm={6}>
            <Form.Group>
              <Form.Label>Selling Rate (₹) *</Form.Label>
              <Form.Control
                ref={sellingRateRef}
                className="right-align"
                name="sellingRate"
                type="number"
                value={formData.sellingRate}
                onChange={handleChange}
                placeholder="0"
                min="0"
                step="0.01"
                onKeyPress={handleSellingRateKeyPress}
                disabled={loading}
              />
            </Form.Group>
          </Col>

          <Col lg={2} md={2} sm={6}>
            <Form.Group>
              <Form.Label>Quantity *</Form.Label>
              <Form.Control
                ref={qtyRef}
                className="right-align"
                name="qty"
                type="number"
                value={formData.qty}
                onChange={handleChange}
                placeholder="0"
                min="1"
                onKeyPress={handleQtyKeyPress}
                disabled={loading}
              />
            </Form.Group>
          </Col>
          */}
        </Row>

        {/* Invoice Items Table */}
        <Row className="mt-4">
          <Col xs={12}>
            <div className="table-responsive">
              <Table bordered className="purchase-table">
                <thead className="table-dark">
                  <tr>
                    <th width="5%">Sno</th>
                    <th width="25%">Product Name</th>
                    {/* <th width="15%">HSN Code</th> */}
                    <th width="15%">Selling Rate (₹)</th>
                    <th width="10%">Qty (Kgs)</th>
                    <th width="15%">Total (₹)</th>
                    <th width="10%">Del</th>
                  </tr>
                </thead>
                <tbody>
                  {invoiceItems.map((item, index) => (
                    <tr key={index}>
                      <td className="text-center">{index + 1}</td>
                      <td>{item.product_name}</td>
                      {/* <td className="text-center">{item.product_code}</td> */}
                      <td>
                        <Form.Control
                          type="number"
                          value={item.selling_rate}
                          className="right-align"
                          onChange={(e) => handleItemChange(index, 'selling_rate', e.target.value)}
                          placeholder="0"
                          min="0"
                          step="0.01"
                          disabled={loading}
                        />
                      </td>
                      <td>
                        <Form.Control
                          type="number"
                          value={item.quantity}
                          onChange={(e) => handleItemChange(index, 'quantity', e.target.value)}
                          placeholder="0"
                          min="1"
                          step="0.01"
                          className="right-align"
                          disabled={loading}
                        />
                      </td>
                      <td className="text-center">₹{item.total.toFixed(2)}</td>
                      <td className="text-center">
                        <FaTrash
                          className="delete-icon"
                          style={{ cursor: loading ? 'not-allowed' : 'pointer', color: '#dc3545', opacity: loading ? 0.5 : 1 }}
                          onClick={() => !loading && handleDeleteItem(index)}
                          title="Delete Item"
                        />
                      </td>
                    </tr>
                  ))}
                  {invoiceItems.length === 0 && (
                    <tr>
                      <td colSpan="7" className="text-center text-muted py-3">
                        {formData.delivery_note_id
                          ? "Delivery note loaded. Add invoice items manually below."
                          : "No items added yet. Enter delivery note number to set customer or manually add items."}
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </Col>
        </Row>

        {renderError("items")}

        {/* Totals Section with Notes */}
        <Row className="mt-4">
          <Col lg={8} md={8} sm={12}>
            <Form.Group>
              <Form.Label>Notes (Optional)</Form.Label>
              <Form.Control
                ref={notesRef}
                name="notes"
                as="textarea"
                rows={3}
                value={formData.notes}
                onChange={handleChange}
                placeholder="Enter any notes..."
                disabled={loading}
              />
            </Form.Group>
          </Col>

          <Col lg={4} md={4} sm={12} className="d-flex justify-content-end">
            <div className="totals-section">
              <div className="total-row">
                <span className="total-label">Subtotal:</span>
                <span className="total-value">₹{calculateSubTotal().toFixed(2)}</span>
              </div>
              <div className="total-row">
                <span className="total-label">
                  GST (
                  <Form.Control
                    type="number"
                    name="gst_percentage"
                    value={formData.gst_percentage}
                    onChange={handleGstChange}
                    className="gst-input"
                    min="0"
                    max="100"
                    step="0.1"
                    disabled={loading}
                  />
                  %)
                </span>
                <span className="total-value">₹{calculateGST().toFixed(2)}</span>
              </div>
              {/* <div className="total-row">
                <span className="total-label">Package Charges ( {packing_percentage}% ):</span>
                <div className="d-flex align-items-center">
                  
                  <span className="total-value ms-2">₹{calculatePackageCharges().toFixed(2)}</span>
                </div>
              </div> */}
              <div className="total-row grand-total">
                <span className="total-label">Grand Total:</span>
                <span className="total-value">₹{calculateGrandTotal().toFixed(2)}</span>
              </div>
            </div>
          </Col>
        </Row>

        <div className="d-flex justify-content-end mt-4 gap-2">
          <Button
            type="submit"
            className="btn-submit"
            disabled={loading || invoiceItems.length === 0}
          >
            {loading ? (
              <>
                <Spinner as="span" animation="border" size="sm" className="me-2" />
                Creating...
              </>
            ) : (
              "Create Invoice"
            )}
          </Button>
          <Button
            type="button"
            className="btn-top"
            onClick={() => navigate(-1)}
            disabled={loading}
          >
            Cancel
          </Button>
        </div>
      </Form>

      {/* Add Customer Modal */}
      <Modal show={showCustomerModal} onHide={handleCloseCustomerModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Add New Customer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {customerSuccess && (
            <Alert variant="success" className="mb-3">
              {customerSuccess}
            </Alert>
          )}

          {customerErrors.api && (
            <Alert variant="danger" className="mb-3">
              {customerErrors.api}
            </Alert>
          )}

          <Form onKeyDown={handleCustomerKeyDown}>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Customer Name *</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    value={newCustomer.name}
                    onChange={handleNewCustomerChange}
                    placeholder="Enter customer name"
                    required
                    isInvalid={!!customerErrors.name}
                    autoFocus
                  />
                  {renderCustomerError("name")}
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Mobile *</Form.Label>
                  <Form.Control
                    type="text"
                    name="mobile"
                    value={newCustomer.mobile}
                    onChange={handleNewCustomerChange}
                    placeholder="Enter 10-digit mobile number"
                    maxLength="10"
                    required
                    isInvalid={!!customerErrors.mobile}
                  />
                  {renderCustomerError("mobile")}
                </Form.Group>
              </Col>
            </Row>

            <Form.Group className="mb-3">
              <Form.Label>Address</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="address"
                value={newCustomer.address}
                onChange={handleNewCustomerChange}
                placeholder="Enter address"
              />
            </Form.Group>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>City</Form.Label>
                  <Form.Control
                    type="text"
                    name="city"
                    value={newCustomer.city}
                    onChange={handleNewCustomerChange}
                    placeholder="Enter city"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>State</Form.Label>
                  <Form.Control
                    type="text"
                    name="state"
                    value={newCustomer.state}
                    onChange={handleNewCustomerChange}
                    placeholder="Enter state"
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Pin Code</Form.Label>
                  <Form.Control
                    type="text"
                    name="pin_code"
                    value={newCustomer.pin_code}
                    onChange={handleNewCustomerChange}
                    placeholder="Enter pin code"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>GST Number (Optional)</Form.Label>
                  <Form.Control
                    type="text"
                    name="gst_no"
                    value={newCustomer.gst_no}
                    onChange={handleNewCustomerChange}
                    placeholder="Enter GST number"
                  />
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleCloseCustomerModal}
            disabled={isAddingCustomer}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleAddCustomer}
            disabled={!newCustomer.name.trim() || !newCustomer.mobile.trim() || isAddingCustomer}
          >
            {isAddingCustomer ? (
              <>
                <Spinner as="span" animation="border" size="sm" className="me-2" />
                Adding...
              </>
            ) : (
              "Add Customer"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default AddInvoice;